import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DialogModule } from '@angular/cdk/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';

import { CardSoftwareLibraryModule } from '@card-software/library';
import { siteInterceptor, SITE_API_BASE_URL } from '@card-software/nexus-utilities';
import { authInterceptor } from './auth.interceptor';

//Prime NG
import { PrimengModule } from './primeng/primeng.module';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import SierraTheme from './primeng/sierra.theme';

import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomTranslateLoader } from './services/custom.translate.loader';
import { environment } from '../environments/environment';

import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MaintenanceReportsComponent } from './components/maintenance-reports/maintenance-reports.component';
import { MaintenanceReportsFormModalComponent } from './components/_modals/maintenance-reports-form-modal/maintenance-reports-form-modal.component';

@NgModule({
  declarations: [AppComponent, LoginComponent, DashboardComponent, MaintenanceReportsComponent, MaintenanceReportsFormModalComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    CardSoftwareLibraryModule,
    ReactiveFormsModule,
    FormsModule,
    DialogModule,
    PrimengModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatIconModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
      },
    }),
  ],
  providers: [
    provideHttpClient(withInterceptors([authInterceptor, siteInterceptor])),
    { provide: SITE_API_BASE_URL, useValue: environment.proxyUrls.userMasterApi },
    provideAnimationsAsync(),
    MessageService,
    providePrimeNG({
      theme: {
        preset: SierraTheme,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    TranslateService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
